<template>
  <section class="proposta">
    <spinner />
    <toaster />
    <a href="#" class="btnClose large" @click.prevent="close()">
    </a>
    <nav>
      <!-- <a href="#" class="btn btn-primary btPrint" @click.prevent="toggleSend()">Enviar por email &nbsp;<fa :icon="['far','paper-plane-top']" class="i"/></a> -->
      <a href="#" class="btn btn-primary btPrint" @click.prevent="print()">Imprimir &nbsp;<fa :icon="['far','print']" class="i"/></a>
    </nav>
    <div class="frame mid">
      <header class="pageHeader">
        <div>
          <logo class="logoRede" color="#ED1C24" size="80px"/>
          <div v-if="unidade">
            <h5>{{ unidade.descricao }}</h5>
            <p>{{ unidade.endereco }}, {{ unidade.numero }} - {{ unidade.bairro }}</p>
            <p>{{ unidade.cidade }}/{{ unidade.uf }} - {{ maskCEP(unidade.cep) }}</p>
            <p>CNPJ: {{ maskCNPJ(unidade.cnpj) }} - rededecisao.com.br</p>
          </div>
        </div>
        <div>
          <p>{{ today() }}</p>
        </div>
      </header>
      <div class="subheader">
        <h1>Proposta de Valores de Matrícula</h1>
        <p class="frame mini">Os valores listados abaixo são referentes a Plataforma Educacional Decisão, que inclue os serviços escolares, materiais didáticos de alta qualidade e acesso às plataformas digitais.</p>
        <span>
          <input-control v-model="responsavel" cssClass="transparent text-center respInput large-text" placeholder="Nome do Responsável"/>
        </span>
        <div>
          <div>
            <h4>
              {{ data.plano.descricao }}
            </h4>
            <p><b>De <del>{{ formatMoney(data.plano.valorTotal) }}</del> por {{ formatMoney(data.plano.valorTotalDesconto) }}, com {{ data.plano.desconto }}% de desconto</b></p>
          </div>
          <div>
            <h4>
              {{ data.plano.nomeExibicao }} - {{ data.plano.mensalidades.mesFinal.split("/")[1] }}
            </h4>
            <p>
              Proposta válida até <b>{{ validadePlano()}}</b>
            </p>
          </div>
        </div>
      </div>
      <div>
        <table v-if="parcelas">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Parcela</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="parcela in parcelas" :key="parcela">
              <td>{{ parcela.tipo }}</td>
              <td>{{ parcela.mes }}</td>
              <td>{{ parcela.valor }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <footer>
        <h5>{{ currentUser.nome }}</h5>
        <p>{{ currentUser.funcao.nome }}</p>
      </footer>
    </div>
    <modal ref="modal" wrapped>
      <div class="senderWrap">
        <input-control v-model="sendTo" placeholder="E-mail do responsável" />
        <footer>
          <a href="#" class="btn btn-primary" @click.prevent="send()">Enviar</a>
          <a href="#" class="btn btn-secondary" @click.prevent="cancelSend()">Cancelar</a>
        </footer>
      </div>
    </modal>
  </section>
</template>

<script>
import { formatMoney, today, maskCEP, maskCNPJ, formatDate } from '@/services/utils.service.js'
import MatriculaService from '@/services/matricula.service.js'
import Logo from '@/components/template/logo.vue'
import moment from 'moment'
import Modal from "@/components/utilities/Modal.vue"

export default {
  components: {
    Logo, Modal
  },
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      parcelas: null,
      unidade: null,
      responsavel: null,
      sendTo: null,
      currentUser: localStorage.getItem('profile') ? JSON.parse(atob(localStorage.getItem('profile'))) : null,
    }
  },
  mounted () {
    console.log("proposta data:", this.data)
    if ( this.data ) {
      this.setup()
      this.getUnidade(this.data.plano.idUnidade)
    }
  },
  methods: {
    setup () {
      const { plano } = this.data

      const parcelas = []

      if ( plano.entrada ) {
        const mesInicioEntrada = plano.entrada.mesInicio
        const parsedMim = mesInicioEntrada.split("/")[0]
        const mim = parseFloat(parsedMim)

        const mesFinalEntrada = plano.entrada.mesFinal
        const parsedMfm = mesFinalEntrada.split("/")[0]
        const mfm = parseFloat(parsedMfm)

        const ano = mesFinalEntrada.split("/")[1]

        for ( let i = mim; i <= mfm; i++ ) {
          const mes = i < 10 ? ('0' + i) : i
          parcelas.push({ tipo: 'Entrada', mes: `${mes}/${ano}`, valor: formatMoney(plano.entrada.valorParcelaDesconto) })
        }
      }
      if ( plano.mensalidades ) {
        const mesInicioMensalidade = plano.mensalidades.mesInicio
        const parsedMim = mesInicioMensalidade.split("/")[0]
        const mim = parseFloat(parsedMim)

        const mesFinalMensalidade = plano.mensalidades.mesFinal
        const parsedMfm = mesFinalMensalidade.split("/")[0]
        const mfm = parseFloat(parsedMfm)

        const ano = mesFinalMensalidade.split("/")[1]

        for ( let i = mim; i <= mfm; i++ ) {
          const mes = i < 10 ? ('0' + i) : i
          parcelas.push({ tipo: 'Mensalidade', mes: `${mes}/${ano}`, valor: formatMoney(plano.mensalidades.valorParcelaDesconto) })
        }
      }

      this.parcelas = parcelas
    },
    getUnidade ( idUnidade ) {
      MatriculaService.getUnidades().then(
        response => {
          this.unidade = response.data.filter( a => a.idUnidade == idUnidade )[0]
          console.log("undidade:", this.unidade)
        },
        error => {
          console.error(error.response.data)
          window.spinner.emit('close')
        }
      )
    },
    maskCNPJ(cnpj) {
      return maskCNPJ(cnpj)
    },
    maskCEP ( zip ) {
      return maskCEP(zip)
    },
    formatMoney ( value ) {
      return formatMoney(value)
    },
    formatDate ( value ) {
      return formatDate(value)
    },
    today ( type ) {
      return today(type)
    },
    validadePlano () {
      const validade = moment(this.data.plano.dataFinal)
      const lastDate = moment().add(5,'days')
      
      const isBefore = validade.isBefore(lastDate)

      if ( isBefore ) {
        return validade
      } else {
        return moment(lastDate).format("DD/MM/YYYY")
      }
    },
    close () {
      localStorage.removeItem('proposta')
      window.close()
    },
    print() {
      window.print()
    },
    toggleSend () {
      const options = {
        title: 'Enviar Proposta',
        titleAlign: "center",
        message: "Informe abaixo o e-mail do responsável que receberá a proposta.", //não obrigatório
        size: "small", //small, mid, normal, large, full
        backdrop: true,
        backdropColor: "transparent",  //se o backdrop for false, não precisa
        backdropClose: true,
        onClose: this.send
      }

      console.log("toggleTransfer:", options)
      this.$refs.modal.open(options)
    },
    send () {
      if ( this.validateEmail() ) {
        const drop = {
          hoje: today(),
          unidade: this.unidade,
          responsavel: this.responsavel,
          parcelas: this.parcelas,
          user: this.currentUser,
          destinatario: this.sendTo,
          plano: this.plano
        }

        MatriculaService.sendProposta( drop ).then(
          response => {
            window.spinner.emit('close')
            if ( response.status == 200 ) {
              window.toaster.emit('open', {style: "success", message: "Email enviado com sucesso para: " + this.pessoa.dados.Basicos.email, floater: true})
            }
          },
          error => {
            console.error(error)
            window.toaster.emit('open', {style: "error", message: "Ops! Algo aconteceu. Não foi possível enviar o email com a declaração.", floater: true})
          }
        )
      } else {
        window.toaster.emit('open', {style: "error", message: "Ops! Parece haver algo errado com o email. Valide e tente novamente.", floater: true})
      }
      
    },
    cancelSend () {
      this.$refs.modal.close()
    },
    validateEmail () {
      const email = this.sendTo
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const test = regex.test(email)

      console.log('email:', email)
      console.log('test:', test)
      
      return test
    }
  }
}
</script>

<style lang="scss" scoped>
  .proposta {
    display: block;
    width: 100vw; min-height: 100vh;
    background-color: $color-secondary;
    padding: $mg;
    overflow-y: auto;
    @extend %scrollbar;

    nav {
      position: fixed;
      top: 0; left: 100px;
      display: flex; gap: $mg_mini;

      .btClose {
        border-top-left-radius: 0; border-top-right-radius: 0;
        border-bottom-left-radius: $border-radius; border-bottom-right-radius: $border-radius;

        .i {
          font-size: 14px
        }
      }

      .btPrint {
        border: 0 !important;
        border-top-left-radius: 0; border-top-right-radius: 0;
        border-bottom-left-radius: $border-radius; border-bottom-right-radius: $border-radius;

        &:hover{
          border: 0 !important;
        }
      }
    }
  }
  
  .btnClose {
    position: absolute;
    top: $mg; right: $mg;
  }

  .subheader {
    margin-bottom: $mg;

    h1 {
      text-align: center;
      margin-bottom: $hmg_mid;
    }
    > p {
      text-align: center;
      margin-bottom: $mg;
    }
    >span {
      display: block;
      margin-bottom: $mg;
    }

    > div {
      display: flex;
      justify-content: space-between;
      border-top: $border-component;
      border-bottom: $border-component;
      padding: $hmg 0;
      

      p {
        margin: 0;
        font-size: 16px;
      }

      > div {
        &:last-child {
          text-align: right;
        }
      }
    }
  }
  .pageHeader {
    display: flex;
    width: 100%; justify-content: space-between;
    align-items: flex-start; 
    line-height: 1.4;
    padding: 0; margin-bottom: $mg;

    >div {
      display: flex;
      gap: $hmg_mid;
      align-items: center;
      

      &:last-child {
        text-align: right;
      }
    }
    p,h5 {
      margin: 0; padding: 0;
    }

    @media screen and (max-width: 689px) {
      flex-direction: column-reverse;
      >div:last-child {
        margin-bottom: $hmg_mid;
      }
    }
  }
  
  footer:not(.senderWrap footer) {
    margin-top: $mg;
    border-top: $border-component;
    padding-top: $hmg
  }
  table {
    border: $border-component;
    border-collapse: collapse;
    width: 100%;

    thead {
      tr {
        th{
          background-color: $color-bg;
          font-weight: bold;
          padding: $mg_mini;
          border: $border-component;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: $mg_mini;
          border: $border-component;
          font-size: 15px;
        }
      }
    }
  }
  
  .senderWrap {
    footer {
      display: flex; justify-content: space-between;
      margin-top: $hmg_mid
    }
  }
  @media print {
    nav {
      display: none !important;
    }
    table {
      break-inside: auto;
      page-break-inside: auto;

      thead {
        display: table-header-group; /* Ensures the header is repeated on new pages */
      }

      tbody {
        display: table-row-group;
      }

      tr {
        page-break-inside: avoid; /* Prevent individual row breaking */
      }

      td, th {
        page-break-inside: avoid;
        page-break-after: auto;
      }

      th {
        -webkit-print-color-adjust: exact; /* Ensures colors print in WebKit browsers */
        print-color-adjust: exact;
        color: #444;
        // background-color: rgb(100,100,100);
      }
    }
  }
</style>